export default "__VITE_ASSET__HjVtYCaj__"